import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { SoundState } from "./type";

/**
 * Sound on, at a bit over half.
 *
 * On by default because a game that makes no sound until the player goes
 * looking for a setting is, for most of them, a game with no sound. The level
 * is the compromise: audible on laptop speakers without being the loudest tab
 * somebody has open, and the engine's own ceiling sits under it besides.
 */
const initialState: SoundState = {
  muted: false,
  volume: 0.6,
};

const soundSlice = createSlice({
  name: "sound",
  initialState,
  reducers: {
    setMuted: (state, action: PayloadAction<boolean>) => {
      state.muted = action.payload;
    },
    toggleMuted: (state) => {
      state.muted = !state.muted;
    },
    setVolume: (state, action: PayloadAction<number>) => {
      state.volume = Math.max(0, Math.min(1, action.payload));
      // Dragging the slider off zero is the player asking for sound, so it
      // un-mutes rather than leaving them with a level and still no audio.
      if (state.volume > 0) state.muted = false;
    },
  },
});

export default soundSlice.reducer;

export const { setMuted, toggleMuted, setVolume } = soundSlice.actions;
